import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { setCookie, getCookie } from 'cookies-next';
import { COOKIE_ANON_SESSION_ID } from 'src/constants';

export function useAnonSessionId() {
  const [anonSessionId, setAnonSessionId] = useState<string | null>(null);

  useEffect(() => {
    const existingAnonSessionId = getCookie(COOKIE_ANON_SESSION_ID);
    if (!existingAnonSessionId) {
      const newAnonSessionId = uuidv4();
      void setCookie(
        COOKIE_ANON_SESSION_ID,
        newAnonSessionId,
        {
          secure: true,
          sameSite: 'strict',
        },
      );
      setAnonSessionId(newAnonSessionId);
    } else {
      setAnonSessionId(existingAnonSessionId as string);
    }
  }, []);

  return anonSessionId;
}
